import { Component } from '@angular/core';
import { AppConfig } from '../../../app/app.config';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { VoyageLogService } from '../../../services/voyage-log/voyage-log.service';
import { VoyageLogAdjustmentEditor, VoyageLogAdjustmentMetadata } from '../../../models/voyage-log/voyagelog.models';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { DateTime } from 'luxon';
import { ApiOption } from '../../../_foundation/models/base.models';
import { DateService } from '../../../services/date/date.service';

@Component({
  selector: 'voyage-log-adjustment-modal',
  templateUrl: 'voyage-log-adjustment-modal.html'
})
export class VoyageLogAdjustmentModalComponent {
  config = AppConfig.settings;
  loading: boolean;
  saveLoading: boolean;
  metadata: VoyageLogAdjustmentMetadata;
  editor: VoyageLogAdjustmentEditor;
  voyageLogId: number;
  dailyLogDate: PtLuxonDate;
  showAlert: boolean;
  alertTextArray: string[];
  mask: Array<string | RegExp> = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];

  constructor(private navCtrl: NavController,
              private navParams: NavParams,
              private voyageLogService: VoyageLogService,
              private toastCtrl: ToastController,
              private viewController: ViewController,
              private dateService: DateService) {
    this.voyageLogId = this.navParams.get('voyageLogId');
    this.dailyLogDate = this.navParams.get('dailyLogDate');
  }

  ionViewDidLoad() {
    this.loadAdjustmentMetadata();
  }

  regexChange(inputTime: string) {
    if (inputTime.charAt(0) === '2') {
      this.mask[1] = new RegExp('[0-3]');
    } else {
      this.mask[1] = new RegExp('\\d');
    }
  }

  closeModal(save: boolean) {
    if (!save) {
      this.viewController.dismiss();
    } else {
      this.saveAdjustmentEditor();
    }
  }

  private async loadAdjustmentMetadata() {
    this.loading = true;
    this.metadata = await this.voyageLogService.getAdjustmentMetadata(this.dailyLogDate.dateTime);
    this.loadEditor();
    this.loading = false;
  }

  private saveAdjustmentEditor() {
    this.saveLoading = true;
    this.alertTextArray = null;
    this.showAlert = false;

    this.voyageLogService.saveAdjustmentEditor(this.editor).subscribe(res => {
      this.presentUploadToast();
      this.viewController.dismiss({choice: true, updatedLog: res});
    }, error => {
      this.showAlert = true;
      this.alertTextArray = error.error.errors.map(m => m.message) as string[];
      this.saveLoading = false;
    })
  }

  private presentUploadToast(): Promise<any> {
    const toast = this.toastCtrl.create({
      message: 'Adjustment Saved',
      duration: 3000,
      position: 'bottom'
    });

    return toast.present();
  }

  private loadEditor() {
    this.editor = new VoyageLogAdjustmentEditor(this.dailyLogDate, this.voyageLogId);
  }

  timeChanged($event: DateTime) {

  }

  offsetChanged(ptLuxonDate: PtLuxonDate) {
    this.editor.dateOffset = ptLuxonDate.dateTime.offset / 60;
  }

  async timeShowChanged() {
    const timeValid = this.dateService.timeIsValid(this.editor.timeToShow);

    if (!timeValid || this.editor.timeToShow === '') {
      return;
    }

    this.editor.date = await this.dateService.setPtLuxonDateFromUserEnteredString(this.editor.timeToShow, this.editor.date.dateTime);
  }

  locationChanged(selectedLocation: ApiOption<number>) {
    this.editor.locationId = selectedLocation.id;
    this.editor.selectedLocation = selectedLocation;
  }

  operationChanged(selectedOperation: ApiOption<number>) {
    this.editor.projectSpecificOperationId = selectedOperation.id;
    this.editor.selectedOperation = selectedOperation;
  }
}



// WEBPACK FOOTER //
// ./src/pages/voyage-log/voyage-log-adjustment-modal/voyage-log-adjustment-modal.ts